// eslint-disable-next-line no-use-before-define
import React from 'react';
import { useTranslation } from 'react-i18next';
import { chatIconBase64 } from '../../../assets/base64/chat-icon';
import { ButtonContainer } from './style';
export const ChatDrawerButtonComponent = ({ onClick, visible, }) => {
    const { t } = useTranslation('drawerChat');
    if (visible === false) {
        return null;
    }
    return (React.createElement(ButtonContainer, null,
        React.createElement("button", { className: "tooltip", onClick: onClick },
            React.createElement("span", { className: "tooltiptext" }, t('drawerChat:tooltipBtnChat')),
            React.createElement("img", { className: "chat-icon", src: chatIconBase64, alt: t('drawerChat:tooltipBtnChat') }))));
};
//# sourceMappingURL=component.js.map